module.exports = "//static.hsappstatic.net/WebsiteGraderUI/static-1.1473/img/chat-person.png"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./img/chat-person.png
// module id = 102
// module chunks = 0 1